var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5024_165631)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5024_165631",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000762939 0H14.0002V13.9148H0.000762939V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5024_165631)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 3.13425 10.8657 0 7 0C3.13425 0 0 3.13425 0 7C0 10.4942 2.55967 13.3898 5.90625 13.9148V9.02417H4.12883V7H5.90625V5.45767C5.90625 3.70358 6.95158 2.73467 8.5505 2.73467C9.31583 2.73467 10.1173 2.87117 10.1173 2.87117V4.59375H9.23417C8.36442 4.59375 8.09317 5.13333 8.09317 5.68692V7H10.0345L9.72417 9.02358H8.09317V13.9148C11.4403 13.3898 14 10.4942 14 7Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72482 9.02329L10.0352 6.99971H8.09382V5.68662C8.09382 5.13304 8.36507 4.59346 9.23482 4.59346H10.1174V2.87087C10.1174 2.87087 9.31591 2.73438 8.55057 2.73438C6.95166 2.73438 5.90632 3.70271 5.90632 5.45737V6.99971H4.12891V9.02329H5.90632V13.9145C6.63105 14.0283 7.36909 14.0283 8.09382 13.9145V9.02387H9.72482",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5024_165631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.91a2ebd4dcb523a8be27f415e58cf165.svg";
export { ForwardRef as ReactComponent };